import React from 'react';
import { Chip, List } from '@mui/material';
import { InformationCardItem } from '@europrocurement/flexy-components';
import { Tiers } from '@europrocurement/l2d-modules/providers/TiersProvider';

export type PrescriberInfoCardViewProps = {
    tiers: Tiers;
};

const PrescriberInfoCardView: React.FunctionComponent<PrescriberInfoCardViewProps> = function ({
    tiers,
}) {
    const hasMultibureaux = tiers.multibureaux && tiers.multibureaux.length > 0;

    return (
        <List className="body">
            <InformationCardItem
                label="Raison sociale"
                value={tiers.raisonSociale || '-'}
            />
            <InformationCardItem
                label="Code client"
                value={tiers.codeComptable || '-'}
            />
            {hasMultibureaux && (
                <InformationCardItem
                    label="Multibureau"
                    value={
                        <Chip
                            label="Compte multibureau actif"
                            color="primary"
                            size="small"
                            variant="outlined"
                        />
                    }
                />
            )}
            <InformationCardItem
                label="Adresse"
                value={tiers.adresse.fullAddress || '-'}
            />
            <InformationCardItem
                label="SIREN"
                value={tiers.siren || '-'}
            />
            <InformationCardItem
                label="N° TVA intracommunautaire"
                value={tiers.tvaIntracommunautaire || '-'}
            />
            <InformationCardItem
                label="Régime TVA"
                value={tiers.regimeTva || '-'}
            />
        </List>
    );
};

export default PrescriberInfoCardView;
